import React from 'react';
import './Reference.scss';

function Reference() {
  return (
    <div className="reference">
      <p className="reference__copy">
        All Season 1 episodes of{' '}
        <a
          href="https://www.amazon.com/Lord-Rings-Power-Season/dp/B09QH98YG1"
          target="_blank"
          rel="sponsored"
        >
          The Lord of the Rings: The Rings of Power
        </a>{' '}
        are available to stream on Prime Video.
      </p>

      {/* <p className="reference__copy">
        <sup className="reference__sup">2</sup> Lorem ipsum dolor sit amet consectetur adipisicing
        elit. Minima dicta, eius temporibus aspernatur quibusdam sint cumque enim consequuntur nihil
        possimus ullam commodi nostrum officia quod, inventore dolor eligendi eum deserunt?
      </p> */}
    </div>
  );
}

export default Reference;
